require('../bootstrap');

import env from '../config/env';
import router from '../router/index'

const baseURL = env.baseURL;
const normalURL = env.normalURL;

const store = {
    state: {
        user: {
            name: '',
            picture: '',
            job: '',
            email: '',
            id: 0,
        },
        tenant: '',
        authenticated: false,
        token: '',
        api: baseURL,
        mainAPi: baseURL,
        url: normalURL,
        breadcrumbs: [{ name: "Home", route: "/" }],
    },
    getters: {
        token: state => {
            return state.token;
        },
        authenticated: state => {
            if (state.token == null || state.token == 'null') {
                return false;
            }

            return state.authenticated;
        },
        logo: state => {
            return state.logo;
        },
        user: state => {
            return state.user;
        },
        api: state => {
            return state.api;
        },
        breadcrumbs: state => {
            return state.breadcrumbs;
        },
        url: state => {
            return state.url;
        },

    },
    mutations: {

        tenantAuth(state, token) {
            console.log('login tenant')

            const self = this;
            const api = state.api + "getAccessToken";

            axios
                .post(api, {
                    token: token,
                })
                .then((response) => {
                    token = response.data

                    if (token != null && token != undefined) {
                        state.authenticated = true;
                        state.token = token;
                        state.mode = 

                        // localStorage.clear();
                        localStorage.setItem('token', token);

                        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                        self.commit('profileUpdate');
                        router.push('/');
                    }

                })
                .catch((error) => {
                    // this.$message("Erro", error.response, "error");
                });
        },
        managerAuth(state, token) {

            console.log('auth', token)


            //login normal
            console.log('login manager')
            if (token != null && token != undefined) {
                state.authenticated = true;
                state.token = token;
                state.mode = 'manager';

                // localStorage.clear();
                localStorage.setItem('token', token);

                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.commit('profileUpdate');
            }


        },
        profileUpdate(state) {
            let meRoute = 'me'
            let mainRoute = '/'
            const domainDev = env.domainDev ? env.domainDev : false;
            //const domainDev = true;
            //se for dominio principal

            let route = router.app._route.path;

            console.log('profile mode: ' + state.mode)

            if (state.mode == 'manager') {
                meRoute = 'adminMe'
                mainRoute = '/domains'
            }

            axios.post(state.api + meRoute, {
                token: state.token
            })
                .then(response => {
                    state.user.id = response.data.id;
                    state.user.name = response.data.name;
                    state.user.email = response.data.email;
                    state.user.picture = response.data.photo;

                    // se já estiver na rota / não precisar dar push
                    if(route != mainRoute && mainRoute == '/domains'){
                        router.push(mainRoute);
                    }

                })
                .catch(error => {
                    localStorage.clear();
                    router.push('/domains/login');
                });
        },
        updateBreadCrumbs(state, newRoute) {
            if (state.breadcrumbs.length > 1) {
                state.breadcrumbs.pop();
            }
            state.breadcrumbs.push(newRoute)
            // state.breadcrumbs = newRoute;
        }
    },
    actions: {
        initialize(context) {

            console.log('inicializando')

            context.state.api = baseURL;
            context.state.url = normalURL;

            const token = localStorage.getItem('token');
            const mode = localStorage.getItem('mode');
            const tenant = localStorage.getItem('tenant');

            if (mode == '' || mode == undefined) {
                localStorage.clear();
                router.push('/domains/login');
            }

            context.state.mode = mode;

            console.log(' modo atual ' + mode)
            console.log(tenant)
            if (mode == 'manager') {
                context.commit('managerAuth', token);
            }

            if(mode == 'tenant' && tenant != null) {

                console.log('inicializando tenant:' + tenant)
                // context.commit('tenantAuth', token);
                context.state.tenant = tenant;
                context.state.authenticated = true;
                context.state.api = normalURL + tenant + '/api/v1/';
                context.state.url = normalURL + tenant + '/';
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.commit('profileUpdate');
            }

        },

        managerLogin(context, tenant, hashed_token) {
            console.log('manager login', tenant, hashed_token)
            context.state.tenant = tenant;
            context.state.api = baseURL;
            context.state.url = normalURL;


            localStorage.setItem('mode', 'manager');

            context.commit('managerAuth', hashed_token);
        },

        tenantLogin(context, param) {

            console.log('tenant login', param)
            context.state.tenant = param.tenant;
            context.state.api = normalURL + param.tenant + '/api/v1/';
            context.state.url = normalURL + param.tenant + '/';


            localStorage.setItem('mode', 'tenant');
            localStorage.setItem('tenant', param.tenant)

            context.commit('tenantAuth', param.hashed_token);
        }
    }
};

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js